import React from 'react';
import { translate } from '@utils/i18n';
import { Loader, TabView, Text } from '@ui';
import { BrushawayBody } from '@ui/molecules/Brushaway';
import { namespace } from '../constants';
function EmbeddedDeficiencyDetailBody({ isLoading, hasError, tabs }) {
    return (React.createElement(BrushawayBody, { variant: "tabbed" },
        React.createElement("div", { className: "embedded-deficiency-detail__body-content" },
            isLoading && (React.createElement("div", { className: "embedded-deficiency-detail__state" },
                React.createElement(Loader, { vertical: true, title: translate('loading', { namespace: 'generic' }) }))),
            !isLoading && hasError && (React.createElement("div", { className: "embedded-deficiency-detail__state" },
                React.createElement(Text, null, translate('def_error_message', { namespace })))),
            !isLoading && !hasError && React.createElement(TabView, { tabs: tabs }))));
}
export default EmbeddedDeficiencyDetailBody;
